<template>
  <FormContainer without-divider>
    <template #title>Établissement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_1"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Nom et Prénom ou dénomination"
          class="col-22 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_2"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="SIRET"
          class="col-14 col-sm-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_8"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-4 col-md-10 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_9"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-4 col-md-10 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_14"
          :model-value="model?.typePublic"
          label="Type de public"
          class="col-9 col-md-10 col-sm-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_14"
          :model-value="model?.employeur?.etablissement?.dernierEffectifConnuEntreprise?.valeur?.toString()"
          :label="'Dernier effectif connu en ' + model?.employeur?.etablissement?.dernierEffectifConnuEntreprise?.annee?.toString()"
          hint="Information provenant de France Compétences"
          class="col-14 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  const store = useDemandeAFStore()

  const { model } = storeToRefs(store)
</script>

